import * as React from 'react';
import { useSyncExternalStore } from 'use-sync-external-store/shim';
import { createDummyStore } from './dummy-store';

const confirmOnPageExit: OnBeforeUnloadEventHandler = (event) => {
  event.preventDefault();

  return 'Warning: We are currently processing some requests, you may have unsaved changes';
};

const readQueue: ''[] = [];
const saveQueue: ''[] = [];

const readQueueLength = () => readQueue.length > 0;
const saveQueueLength = () => saveQueue.length > 0;

const { subscribe: subscribeRead, emitChange: changeRead } = createDummyStore();
const { subscribe: subscribeSave, emitChange: changeSave } = createDummyStore();

export function startReadRequest() {
  readQueue.push('');
  changeRead();
}

export function startSaveRequest() {
  saveQueue.push('');
  changeSave();
}

export function endReadRequest() {
  readQueue.pop();
  changeRead();
}

export function endSaveRequest() {
  saveQueue.pop();
  changeSave();
}

export function failedSaveRequest() {
  endSaveRequest();

  const systemErrorMessages = document.getElementsByClassName(
    'system_errormessage',
  );
  for (const el of Array.from(systemErrorMessages)) {
    el.classList.add('error');
  }
}

function useSaveInProgress() {
  return useSyncExternalStore(subscribeSave, saveQueueLength);
}

export function useReadOrSaveInProgress() {
  const readInProgress = useSyncExternalStore(subscribeRead, readQueueLength);
  const saveInProgress = useSaveInProgress();

  return saveInProgress || readInProgress;
}

export const NavigationBlocker: React.VFC = () => {
  const saveInProgress = useSaveInProgress();

  React.useEffect(() => {
    if (saveInProgress) {
      window.addEventListener('beforeunload', confirmOnPageExit);

      return () => {
        window.removeEventListener('beforeunload', confirmOnPageExit);
      };
    }
  }, [saveInProgress]);

  return null;
};
